import { TextField, InputAdornment, IconButton, CircularProgress } from '@mui/material';
import { Sell, HowToReg, ConfirmationNumber, Search, Refresh, FileDownload } from '@mui/icons-material';
import useHandleAttendeeSearch from './hooks/useHandleAttendeeSearch';
import LoadingSpinner from '../../../../../animation/LoadingSpinner';
import NotFound from '../../../../../pages/404/NotFound';
import Pagination from '../../../../../components/pagination/Pagination';
import AnalyticsCard from '../../../../../components/Cards/AnalyticsCard';
import AttendeesList from './AttendeesList';
import '../../../../../styles/components/Invitation.css';

export default function RegistrationManage({ parentLoading }) {
    const {
        originalData,
        filteredData,
        searchQuery,
        handleSearchFilter,
        loading,
        onRefresh,
        exportAttendeesList,
        exportLoading,
        error,
        refreshLoading,
        totalRegistrations,
        totalTicketsSold,
        setRowsPerPage,
        currentPage,
        setCurrentPage,
        rowsPerPage
    } = useHandleAttendeeSearch();

    if (loading || parentLoading) {
        return <LoadingSpinner message="Loading your attendees list..." />;
    }

    if (error) {
        return (
            <NotFound
                statusCode={error?.code}
                pageTitle="Error Fetching Registrations"
                description="There was an error while fetching the registrations. Please try again later."
                shouldShowBgGradient={false}
            />
        );
    }

    const analyticsCards = [
        // {
        //     title: 'Total Event Tickets',
        //     value: '541',
        //     valueColor: 'var(--quinary-secondary-color)',
        //     icon: <ConfirmationNumber sx={{ color: 'var(--quinary-secondary-color)' }} />,
        //     iconBgColor: 'var(--quinary-light-bg-color-2)'
        // },
        {
            title: 'Ticket Sold',
            value: totalTicketsSold,
            valueColor: 'var(--success-secondary-color)',
            icon: <Sell sx={{ color: 'var(--success-secondary-color)' }} />,
            iconBgColor: 'var(--success-light-bg-color-2)'
        },
        {
            title: 'Total Registrations',
            value: totalRegistrations,
            valueColor: 'var(--secondary-color)',
            icon: <HowToReg sx={{ color: 'var(--secondary-color)' }} />,
            iconBgColor: 'var(--warning-light-bg-color)'
        },
    ];

    const paginatedData = searchQuery
        ? filteredData.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage)
        : originalData.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);


    return (
        <div className="manage-registration-container">
            <div className="analytics-cards">
                {analyticsCards.map((card, index) => (
                    <AnalyticsCard
                        key={index}
                        title={card.title}
                        value={card.value}
                        valueColor={card.valueColor}
                        iconBgColor={card.iconBgColor}
                        icon={card.icon}
                    />
                ))}
            </div>
            <div className="attendees-searchbar-action-container">
                <div className="attendees-searchbar">
                    <TextField
                        fullWidth
                        placeholder="Name, Email, Phone, Booking ID or Ticket ID"
                        sx={searchbarStyle}
                        value={searchQuery}
                        onChange={(e) => handleSearchFilter(e.target.value)}
                        slotProps={{
                            input: {
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Search color="white" />
                                    </InputAdornment>
                                )
                            }
                        }}
                    />
                </div>
                <div className="attendees-action">
                    <IconButton onClick={onRefresh} disabled={loading}>
                        <Refresh color="secondary" />
                    </IconButton>

                    <IconButton onClick={exportAttendeesList} disabled={exportLoading}>
                        {!exportLoading && <FileDownload color="secondary" />}

                        {exportLoading && (
                            <CircularProgress
                                size={20}
                                sx={{ color: 'var(--secondary-color)' }}
                            />
                        )}
                    </IconButton>

                    <Pagination
                        count={searchQuery ? filteredData.length : originalData.length}
                        page={currentPage - 1}
                        rowsPerPage={rowsPerPage}
                        onPageChange={(event, newPage) => setCurrentPage(newPage + 1)}
                        onRowsPerPageChange={(e) => {
                            setRowsPerPage(parseInt(e.target.value, 10));
                            setCurrentPage(1); // Reset to first page when rows per page changes
                        }}
                        rowsPerPageOptions={[5, 10, 15, 20]}
                    />
                </div>
            </div>
            <AttendeesList
                attendeesList={paginatedData}
                loading={refreshLoading}
            />
        </div>
    );
}

const searchbarStyle = {
    '& .MuiOutlinedInput-root': {
        fontSize: '1rem',
        borderRadius: '0.75rem'
    },
    '& .MuiInputBase-input': {
        padding: '0.75rem 14px',
        paddingLeft: '0'
    }
};